module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "AddToHome"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iosAddShow),
      expression: "iosAddShow"
    }],
    staticClass: "ios"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('i', {
    on: {
      "click": _vm.hideAddHome
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/iamge_nav_cancel@3x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.androidAddShow),
      expression: "androidAddShow"
    }],
    staticClass: "android"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "case",
    attrs: {
      "src": require("../../assets/icon/image_guide_00@2x.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Do not want  to miss the discount?")]), _vm._v(" "), _c('div', {
    staticClass: "content-row"
  }, [_c('p', [_vm._v("Step 1: Tap the share button below")]), _c('img', {
    attrs: {
      "src": require("../../assets/icon/image_guide_01@3x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-row"
  }, [_c('p', [_vm._v("Step 2: Choose “Add to Home Screen”")]), _c('img', {
    attrs: {
      "src": require("../../assets/icon/image_guide_02@3x.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('img', {
    attrs: {
      "src": require("../../assets/icon/image_add_to_homescreen_finger@3x.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49ea0e9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AddToHome.vue
// module id = 269
// module chunks = 18